"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc1155 = exports.erc721 = exports.erc1155abi = exports.erc721abi = void 0;
const contracts_1 = require("./contracts");
exports.erc721abi = require("./abi/ERC721.json");
exports.erc1155abi = require("./abi/ERC1155.json");
function erc721(name, address, extendAbi) {
    const abi = extendAbi ? [...exports.erc721abi, ...extendAbi] : exports.erc721abi;
    const result = (0, contracts_1.contract)(abi, address);
    result.name = name;
    result.address = address;
    result.abi = abi;
    tryTag(address, name);
    return result;
}
exports.erc721 = erc721;
function erc1155(name, address, extendAbi) {
    const abi = extendAbi ? [...exports.erc1155abi, ...extendAbi] : exports.erc1155abi;
    const result = (0, contracts_1.contract)(abi, address);
    result.name = name;
    result.address = address;
    result.abi = abi;
    tryTag(address, name);
    return result;
}
exports.erc1155 = erc1155;
function tryTag(address, name) {
    try {
        if (process.env.NODE)
            eval("require")("./hardhat").tag(address, name);
    }
    catch (ignore) { }
}
